import React, { useState } from "react";
import "./togglePlanCardsStyles.css";
import HealthCardActual from "../healthCardActual/HealthCardActual";
import DentalCardPanhandle from "../dentalCard/DentalCardPanhandle";
import { Enrollments } from "../../../../../types/enrollment.types";
import VisionPlanCardPanhanle from "../visionPlanCard/VisionCardPanhandle";
import { HealthCardAlert } from "../../../../shared";

interface TogglePlanCardsProps {
	healthPlanDetails: Enrollments;
	onCardChange: (activeCard: "health" | "dental" | "vision") => void;
	hasHealthPlan: boolean;
	hasDentalPlan: boolean;
	hasVisionPlan: boolean;
}

const TogglePlanCards: React.FC<TogglePlanCardsProps> = ({
	healthPlanDetails,
	onCardChange,
	hasHealthPlan,
	hasDentalPlan,
	hasVisionPlan
}) => {
	const [activeCard, setActiveCard] = useState<"health" | "dental" | "vision">("health");

	const handleCardToggle = (card: "health" | "dental" | "vision") => {
		setActiveCard(card);
		onCardChange(card);
	};

	return (
		<div className="window-container">
			<div className="window">
				<div className="window-header">
					<button
						className={`tab ${activeCard === "health" ? "active" : ""}`}
						onClick={() => handleCardToggle("health")}
					>
						Health Plan
					</button>
					<button
						className={`tab ${activeCard === "dental" ? "active" : ""}`}
						onClick={() => handleCardToggle("dental")}
					>
						Dental Plan
					</button>
					<button
						className={`tab ${activeCard === "vision" ? "active" : ""}`}
						onClick={() => handleCardToggle("vision")}
					>
						Vision Plan
					</button>
				</div>
				<div className="card-container">
					{activeCard === "health" && (
						<HealthCardActual healthPlanDetails={healthPlanDetails} hasHealthPlan={hasHealthPlan} />
					)}
					{activeCard === "dental" && <DentalCardPanhandle hasDentalPlan={hasDentalPlan} />}
					{activeCard === "vision" && <VisionPlanCardPanhanle hasVisionPlan={hasVisionPlan} />}
				</div>
			</div>
		</div>
	);
};

export default TogglePlanCards;
